import { render, staticRenderFns } from "./WMoney.vue?vue&type=template&id=e56e3116&scoped=true&"
import script from "./WMoney.vue?vue&type=script&lang=js&"
export * from "./WMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56e3116",
  null
  
)

export default component.exports